'use client';

import { useEffect, useState } from 'react';
import { datadogErrorHelper } from '../../common/utils/datadogErrorHelper';
import { DatadogErrorLevels } from '@bts-web/utils-next-infrastructure';
import { getCryptoTransfersTransactions } from '../../common/gqlActions';
import { CryptoTransfersTransactionsItemType } from '../../transaction-details/types';
import { useHandleGqlErrorsWithSnackbar } from '@bts-web/core-features/common';
import { useDrawerMetadata } from '../../common/components/ModalDrawerContext/ModalDrawerContext';

export const useCryptoTransferTransactionDetails = ({
  cryptoTransferId,
}: {
  cryptoTransferId?: string;
}) => {
  const [
    isCryptoTransferTransactionFetching,
    setIsCryptoTransferTransactionFetching,
  ] = useState(true);

  const { closeThisDrawer } = useDrawerMetadata();

  const [cryptoTransferTransaction, setCryptoTransfer] =
    useState<CryptoTransfersTransactionsItemType>(null);

  const { processErrors } = useHandleGqlErrorsWithSnackbar();

  const fetchCryptoTransfersTransactions = async () => {
    try {
      const response = await getCryptoTransfersTransactions({
        id: cryptoTransferId,
      });

      if (response?.errors) {
        closeThisDrawer();

        processErrors(response.errors);

        return;
      }

      const transactionDataObjContainer =
        response?.data?.cryptoTransfersTransactions?.edges;

      if (!transactionDataObjContainer) {
        closeThisDrawer();

        datadogErrorHelper({
          errorMessage: '[CRYPTO DEPOSIT VERIFY NOW] No transaction data found',
          errorSeverity: DatadogErrorLevels.HIGH,
        });

        processErrors();

        return;
      }

      const cryptoTransferTransactionNode =
        transactionDataObjContainer[0]?.node || null;

      setCryptoTransfer(cryptoTransferTransactionNode);
    } catch (error) {
      datadogErrorHelper({
        errorMessage: JSON.stringify(error),
        errorSeverity: DatadogErrorLevels.HIGH,
      });
    }

    setIsCryptoTransferTransactionFetching(false);
  };

  useEffect(() => {
    if (!cryptoTransferId) {
      return;
    }

    fetchCryptoTransfersTransactions();
  }, [cryptoTransferId]);

  return {
    isCryptoTransferTransactionFetching,
    cryptoTransferTransaction,
    refetchCryptoTransfersTransactions: fetchCryptoTransfersTransactions,
  };
};
